import { AssessmentDto } from './assessment.dto';

export class Assessment {
    readonly id: string;
    readonly courseId: string;
    readonly name: string;
    readonly description: string;
    readonly showToAssessor: boolean;

    constructor(dto: AssessmentDto) {
        this.id = dto.id;
        this.courseId = dto.courseId;
        this.name = dto.name;
        this.description = dto.description ?? '';
        this.showToAssessor = dto.showToAssessor ?? false;
    }
}
